import type { GlobalSearchItemDto } from '@sib/api';
import { GlobalSearchHighlightedText } from './GlobalSearchHighlightedText';

interface GlobalSearchItemContentProps {
  item: GlobalSearchItemDto;
  searchTerm: string;
}

export const GlobalSearchItemContent = ({
  item,
  searchTerm,
}: GlobalSearchItemContentProps) => (
  <GlobalSearchHighlightedText
    text={item.title}
    searchTerm={searchTerm}
    className="text-primary truncate text-sm leading-6 font-normal"
  />
);
